// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6bbef1f4] .hide-tab-headers .v-tabs-bar{display:none!important}", ""]);
// Exports
module.exports = exports;
